import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchRecommendedUsers
} from "./recommendedUsers.actions";
import { initialState } from "./recommendedUsers.initial-state";
import { RecommendedUser } from "./recommendedUsers.types";

const recommendedUsersSlice = createSlice({
  name: "recommendedUsers",
  initialState,
  reducers: {
    setRecommendedUsers: (state, action: PayloadAction<RecommendedUser[]>) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecommendedUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRecommendedUsers.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchRecommendedUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch donors";
      })
  },
});

export const {setRecommendedUsers } = recommendedUsersSlice.actions;
const recommendedUsersReducer = recommendedUsersSlice.reducer;
export default recommendedUsersReducer;
